import { create } from 'zustand';

/**
 * Global toast notifier. The prototype dispatches single-message toasts via
 * showToast(msg, type). We replicate the behavior with a Zustand store and
 * an auto-dismiss timer (2.5s, matching the prototype).
 */

export type ToastType = 'success' | 'warning' | 'error' | 'info';

interface ToastState {
  message: string | null;
  type: ToastType;
  show: (message: string, type?: ToastType) => void;
  hide: () => void;
}

let dismissTimer: ReturnType<typeof setTimeout> | null = null;

export const useToast = create<ToastState>((set) => ({
  message: null,
  type: 'info',
  show: (message, type = 'info') => {
    set({ message, type });
    if (dismissTimer) clearTimeout(dismissTimer);
    dismissTimer = setTimeout(() => set({ message: null }), 2500);
  },
  hide: () => {
    if (dismissTimer) clearTimeout(dismissTimer);
    set({ message: null });
  },
}));

/** Convenience exported so feature code can call without the hook. */
export const toast = (message: string, type?: ToastType) =>
  useToast.getState().show(message, type);
